<template>
  <div class="knowlegdebank-list__pagination">
    <button
      v-if="currentPage > 1"
      class="knowlegdebank-list__pagination-next"
      @click="$emit('previousPage', currentPage - 1)"
    >
      <
    </button>
    <button
      :class="{ active: currentPage == n }"
      @click="$emit('goToPage', n)"
      v-for="(n, index) in pageAmount"
      :key="index"
      v-if="
        Math.abs(n - currentPage) < 3 ||
        n === pageAmount ||
        n === 1
      "
    >
      {{ n }}
    </button>
    <button
      v-if="currentPage < pageAmount"
      class="knowlegdebank-list__pagination-prev"
      @click="$emit('nextPage', currentPage + 1)"
    >
      >
    </button>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: ["itemsPerPage", "currentPage", "pageAmount"]
};
</script>
